import Drawer from '@mui/material/Drawer';
import { useTheme } from '@mui/material/styles';

const ToolDrawer = ({ open, onClose, anchor = 'right', children, ...otherProps }) => {
  const theme = useTheme();

  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor={anchor}
      PaperProps={{ sx: { width: 'min(100%, 410px)', boxShadow: '0 1px 5px 0 rgba(127, 127, 227, 0.21)', height: `calc(100% - ${theme.app.tool.headerHeight})`, mt: theme.app.tool.headerHeight } }}
      ModalProps={{ sx: { zIndex: 100, '& .MuiBackdrop-root': { background: 'transparent' } } }}
      {...otherProps}
    >
      {children}
    </Drawer>
  );
}

export default ToolDrawer;